import { Box, TableCell, TableRow, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useState } from 'react';
import ContainerTable, { ContainerFilters, TableHeader } from '../components/Containers/ContainerTable';
import { StatusBadge } from '../components/Containers/StatusBadge';
import { PickUpLocation } from '../components/Containers/PickUpLocation';
import { Container } from '../../types';
import useUtils from '../hooks/useUtils';
import useOwnerId from '../hooks/useOwnerId';
import useGetClient from '../hooks/useGetClient';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingTop: theme.spacing(3.25),
      paddingLeft: theme.spacing(7.5),
      paddingRight: theme.spacing(7.5),
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
    },
  })
);

const PendingTableHead = () => (
  <TableRow>
    <TableHeader label="STATUS" sortField="status" />
    <TableHeader sx={{ minWidth: 120 }} label="CONTAINER #" sortField="containerCode" />
    <TableHeader sx={{ minWidth: 120 }} label="TYPE" sortField="containerTypeCode" />
    <TableHeader sx={{ minWidth: 100 }} label="SHIPPING LINE" sortField="shippingLineCode" />
    <TableHeader sx={{ minWidth: 220 }} label="PICK UP LOCATION" />
    <TableHeader sx={{ minWidth: 160 }} label="BOOKING REF" />
    <TableHeader sx={{ minWidth: 200 }} label="REFERENCE#" sortField="referenceId" />
  </TableRow>
);

const ContainerRow = ({ container }: { container: Container }) => {
  const { getContainerTypeName, getShippingLineName } = useUtils();
  const client = useGetClient(container);
  return (
    <TableRow>
      <TableCell>
        <StatusBadge status={container.status} />
      </TableCell>
      <TableCell>{container.containerCode}</TableCell>
      <TableCell>{getContainerTypeName(container)}</TableCell>
      <TableCell>{getShippingLineName(container)}</TableCell>
      <TableCell sx={{ maxWidth: 220 }}>
        <PickUpLocation client={client} />
      </TableCell>
      <TableCell>{container.shippingLineBookingRef || '—'}</TableCell>
      <TableCell>{container.referenceId}</TableCell>
    </TableRow>
  );
};

const Pending = () => {
  const classes = useStyles();
  const owner_id = useOwnerId();
  const [lastRefeshedAt] = useState(new Date().getTime().toString());

  const containerFilters: ContainerFilters = {
    clientId: undefined,
    requestedByUserId: owner_id,
    statuses: ['pending'],
  };

  return (
    <Box className={classes.container}>
      <Typography variant="h4" color="secondary" mb={4}>
        Pending Reuse Requests
      </Typography>
      <Typography variant="body2" color="textSecondary" mb={3}>
        Containers awaiting shipping-line approval for reuse.
      </Typography>
      <ContainerTable
        {...containerFilters}
        // Most recently requested first, so new requests surface at the top.
        initialSortOptions={[{ direction: 'desc', sortField: 'updated_at' }]}
        tableHead={<PendingTableHead />}
        ContainerRow={ContainerRow}
        lastRefeshedAt={lastRefeshedAt}
      />
    </Box>
  );
};

export default Pending;
